// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"94":"Login","380":"WindHome","684":"Admin","779":"SolarHome"}[chunkId] + "." + {"94":"1cb44b15","380":"2f5ae774","684":"8097d6a9","779":"5cd4bc7d"}[chunkId] + ".css";
};